// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { Text, View } from '@/components/Themed';
import appColors from '@/theme/colors';

// Dev-only screen to prove the JS-thread freeze detector fires: the busy-loop
// blocks the thread for 1.5 s, which must show up as a
// goffy.frontend.jsthread.blocked.duration sample in the next metric.emit.
export default function FreezeDebugScreen() {
  const [lastFreezeMs, setLastFreezeMs] = useState<number | null>(null);

  const simulateFreeze = () => {
    if (!__DEV__) {
      return;
    }
    const start = Date.now();
    const end = start + 1500;
    while (Date.now() < end) {
      // busy-wait on purpose
    }
    setLastFreezeMs(Date.now() - start);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Freeze simulator</Text>
      <Text style={styles.description}>
        Blocks the JS thread for 1.5 s. Expect a jsthread.blocked sample in the next metric flush.
      </Text>
      {__DEV__ ? (
        <Pressable style={styles.button} onPress={simulateFreeze}>
          <Text style={styles.buttonLabel}>Freeze for 1.5 s</Text>
        </Pressable>
      ) : (
        <Text style={styles.description}>Only available in dev builds.</Text>
      )}
      {lastFreezeMs !== null ? <Text style={styles.description}>Last freeze: {lastFreezeMs} ms</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  description: {
    textAlign: 'center',
  },
  button: {
    backgroundColor: appColors.primary,
    borderRadius: 8,
    paddingHorizontal: 20,
    paddingVertical: 12,
  },
  buttonLabel: {
    color: '#fff',
    fontWeight: '600',
  },
});
